/**
 * MP → ORB (uo) conversion rate — 10 MP = 1 ORB.
 */
import { Decimal } from 'decimal.js';

/** MP burned per 1 ORB credited. */
export const MP_PER_UO = 10;

export const MP_TO_UO_RATIO_LABEL = '10:1';

/** ORB received for a given MP amount (decimal string). */
export function mpAmountToUo(mpAmount: string): string {
  return new Decimal(mpAmount).div(MP_PER_UO).toFixed(18);
}

/** MP required to mint `uoAmount` ORB. */
export function uoAmountToMp(uoAmount: string): string {
  return new Decimal(uoAmount).mul(MP_PER_UO).toFixed(18);
}
